// default values for services

import { PAGINATOR } from "./components";

export const DEFAULT_QUERY_PARAMS = {
  pagination: {
    page: PAGINATOR.DEFAULT_PAGE, // leave key in lowercase
    pageSize: PAGINATOR.DEFAULT_PAGE_SIZE, // leave key in lowercase
  },
};
